export const resolveApiBaseUrl = (): string => {
  const envUrl = import.meta.env.VITE_API_URL as string | undefined;

  if (import.meta.env.DEV) {
    return envUrl || 'http://localhost:44333/api';
  }

  return envUrl || `${window.location.origin}/api`;
};

export const API_BASE_URL = resolveApiBaseUrl();
